import React from "react";
import { FAQ_ITEMS } from "../../content/faq";

export default function FAQ() {
  return (
    <section id="faq" className="z-section-compact" data-testid="faq">
      <div className="z-page">
        <h2 className="font-display text-[26px] md:text-[34px] leading-[1.1] max-w-[22ch]">
          Frequently asked questions
        </h2>
        <div className="mt-8 divide-y divide-[hsl(var(--z-border))] border-y border-[hsl(var(--z-border))]">
          {FAQ_ITEMS.map((item, i) => (
            <details
              key={item.q}
              className="group py-5"
              data-testid={`faq-item-${i}`}
            >
              <summary className="flex items-start justify-between gap-6 cursor-pointer list-none marker:content-['']">
                <h3 className="font-display text-[18px] md:text-[20px] leading-snug pr-8">
                  {item.q}
                </h3>
                <span
                  aria-hidden="true"
                  className="text-[hsl(var(--z-teal))] text-xl font-light transition-transform duration-200 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <p className="mt-3 text-[16px] leading-[1.65] text-[hsl(var(--z-text-muted))] max-w-[65ch]">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
